import { useEffect } from 'react'

interface SimpleObjectViewerProps {
  preview_url: string
  model_url: string
}

export default function SimpleObjectViewer({
  preview_url,
  model_url,
}: SimpleObjectViewerProps) {
  // Load model-viewer script
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'module'
    script.src =
      'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js'
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  return (
    <model-viewer
      src={model_url}
      ar
      poster={preview_url}
      shadow-intensity="1"
      camera-controls
      touch-action="pan-y"
    />
  )
}
